<template>
<div class="containers">
    <div v-show="goArea == 'main'" class="area-list">
        <CAlert
        v-if="success == true"
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <CAlert
        v-else
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:red;border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <div class="search-area">
            <CRow>
                <CCol sm="4">
                    <input type="text" v-model="filterGeneric" placeholder="Nama / NIP / Email" class="form-control"/>
                </CCol>
                <CCol sm="4">
                    <div class="autocomplete">
                        <input type="text"
                                class="form-control"
                                @click="toggleVisibleUnit()"
                                @blur="toggleCloseVisibleUnit()"
                                v-text="selectedItemUnit ? selectedItemUnit['text'] : ''"
                                v-model="queryUnit"
                                @keydown.up="upUnit"
                                @keydown.down="downUnit"
                                @keydown.enter="selectItemUnit"
                                placeholder="Pilih Unit Level"
                        >
                        <div class="popovers" v-show="visibleUnit">
                            <div class="options" v-if="matchesUnit.length != 0 && queryUnit.length != 0" ref="optionsList">
                                <ul>
                                <li v-for="(match, index) in matchesUnit"
                                    :key="index"
                                    :class="{ 'selected': (selectedUnit == index)}"
                                    @click="itemClickedUnit(index)"
                                    v-text="match['text']"></li>
                                </ul>
                            </div>
                            <div class="options" v-if="matchesUnit.length == 0 && queryUnit.length != 0">
                                Data Tidak Ditemukan
                            </div>
                            <div class="options" v-if="matchesUnit.length == 0 && queryUnit.length == 0">
                                Start Typing...
                            </div>
                        </div>
                    </div>
                </CCol>
                <CCol>
                    <month-picker-input placeholder="Bulan" :no-default="true" :show-year="true" :default-year="date.year" @change="showDate"></month-picker-input>
                </CCol>
                <CCol sm="2">
                    <CButton style="float:right" @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="2">
                    <CButton @click="goSettings()" type="button" class="btn btn-add">Setting</CButton>
                </CCol>
                <CCol sm="8">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                    <img class="mt-1 mr-5" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                    <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/>
                </CCol>
                <CCol sm="2">
                    <CButton @click="moving('import')" type="button" class="btn btn-add">Import</CButton>
                </CCol>
            </CRow>
        </div>
        <PopUpImport ref="popUpImport" />
        <PopUpSetting ref="settings" @saveSetting="goSaveSetting"/>
        <Tables @edit="editData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
    </div>
    <div v-show="goArea == 'manual'" class="area-edit">
        <CRow class="area-back">
            <CCol sm="12">
                <img class="mt-2 mb-2" @click="moving('main')" :src="backIcon" width="20px" height="20px" style="float:left;cursor:pointer"/>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow class="area-input">
            <CCol sm="12">
                <DetailShift ref="dtlShift" @backFront="getBackFront"/>
            </CCol>
        </CRow>
    </div>
    <div v-show="goArea == 'import'" class="area-edit">
        <CRow class="area-back">
            <CCol sm="12">
                <img class="mt-2 mb-2" @click="moving('main')" :src="backIcon" width="20px" height="20px" style="float:left;cursor:pointer"/>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow class="area-input">
            <CCol sm="12">
                <ImportData ref="importData" @submitImport="submitImport" @backFront="getBackFront"/>
            </CCol>
        </CRow>
    </div>
</div>
</template>

<script>
import Tables from '../../../component/tableShiftNew'
import {DataApi} from "../../../service/DataApi";
import { ModelSelect } from 'vue-search-select'
import PopUpSetting from './PopUpSetting.vue'
import PopUpImport from './PopUpImport.vue'
import DetailShift from './DetailShift.vue'
import ImportData from './ImportData.vue'
import { MonthPickerInput } from 'vue-month-picker'

export default {
    components: {
        ModelSelect,
        Tables,
        PopUpSetting,
        PopUpImport,
        DetailShift,
        ImportData,
        MonthPickerInput,
    },
    data() {
        return {
            success: true,
            // datas
            backIcon: require('../../../assets/menu/icon_goback.svg'),
            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            classReload: 'reloadOff',
            goArea: 'main',
            loading: false,
            alertMess: '',
            currentAlertCounter: 0,
            dataTh: [
                'Nama',
                'NIP',
                'Email',
                'Unit Level',
                'Periode',
                'Total Jadwal',
                'Action'
            ],
            dataTd: [
                'nama',
                'nip',
                'email',
                'unit',
                'bulanTahunText',
                'totalJadwal',
                'action'
            ],
            styleTable: ['200px', '100px', '150px', '200px', '75px', '75px', '75px',],
            classReload: 'reloadOff',
            datas: [],

            // data model
            tipe: 'C',

            // paging
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // filter
            filterGeneric: '',
            // data search unit
            dataUnit: [],
            titleUnit:"Pilih Unit Level",
            selectedItemUnit: null,
            selectedUnit: 0,
            queryUnit: '',
            visibleUnit: false,
            idUnits: '',

            date: {
                from: null,
                to: null,
                month: null,
                monthIndex: null,
                year: null
            },
            tanggal: new Date(),

            // error
            errorMessage: '',
            flagSearch: false,

            dataSetting: []
        }
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        filterGeneric() {
            this.flagSearch = true
        },
        queryUnit() {
            this.getDataUnit()
            this.flagSearch = true
        },
        goArea() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        date() {
            this.flagSearch = true
        }
    },
    methods: {
        /**
         * SEARCH UNIT LEVEL
         */
        getDataUnit() {
            let unit = this.queryUnit
            let payload = {
                limit: 10,
                namaUnit: unit,
                pageIn: 1,
                namaParentUnit: '',
                idUnit: ''
            }
            DataApi.post("unit/get", payload)
            .then(res => {
                this.dataUnit = []
                let response = res.data.data
                let tempData = response.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = ''
                    if(tempData[i].parentBidang == null || tempData[i].parentBidang == 'null') {
                        onPush = {
                            value: tempData[i].id,
                            text: tempData[i].bidang
                        }                      
                    } else {
                        onPush = {
                            value: tempData[i].id,
                            text: tempData[i].bidang + ' - ' + tempData[i].parentBidang                            
                        }
                    }
                    this.dataUnit.push(onPush)
                }
            })
        },
        toggleVisibleUnit() {
            this.visibleUnit = true;
        },
        hideUnit() {
            this.visibleUnit = false;
        },
        toggleCloseVisibleUnit() {
            setTimeout(this.hideUnit, 1000);
        },
        itemClickedUnit(index) {
            this.selectedUnit = index;
            this.selectItemUnit();
        },
        selectItemUnit() {
            if (!this.matchesUnit.length) {
            return;
            }
            this.selectedItemUnit = this.matchesUnit[this.selectedUnit];
            this.visibleUnit = false;
            this.queryUnit = this.selectedItemUnit.text
            this.idUnits = this.selectedItemUnit.value
            if (this.shouldReset) {
            this.queryUnit = '';
            this.selectedUnit = 0;
            }
        },
        upUnit() {
            if (this.selectedUnit == 0) {
            return;
            }
            this.selectedUnit -= 1;
            this.scrollToItemUnit();
        },
        downUnit() {
            if (this.selectedUnit >= this.matchesUnit.length - 1) {
            return;
            }
            this.selectedUnit += 1;
            this.scrollToItemUnit();
        },
        scrollToItemUnit() {
            this.$refs.optionsList.scrollTop = this.selectedUnit * this.itemHeight;
        },


        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true

            let payload = {
                bulan: this.date.monthIndex,
                filterGeneric: this.filterGeneric,
                lvl: this.queryUnit != '' ? this.idUnits : '',
                tahun: this.date.year,
                limit: this.size,
                pageIn: this.page,
            }
            DataApi.post("shift/jadwal/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        findData() {
            this.getData()
        },
        reload() {
            this.searchKode = ''
            this.searchDeskripsi = ''
            this.flagSearch = true
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },

        /**
         * ADD DATA
         */
        moving(val) {
            setTimeout(this.moveArea(val), 200);
        },
        moveArea(val) {
            if(val == 'main') {
                this.$refs.dtlShift.clearData()
                this.$refs.importData.clearData() 
            }
            this.goArea = val
        },
        /**
         * EDIT DATA
         */
        editData(value) {
            this.$store.state.loadingScreen = true
            let temp = this.datas[value]
            let payload = {
                bulan: temp.bulanTahun.split("-")[1],
                idPegawai: temp.idPegawai,
                tahun: temp.bulanTahun.split("-")[0]
            }
            DataApi.post('shift/jadwal/detail', payload)
            .then( res => {
                let resp = res.data
                this.$refs.dtlShift.datas = temp
                this.$refs.dtlShift.dataTable = resp.data
                this.moving('manual')
                this.$store.state.loadingScreen = false
            })
        },

        setDate() {
            let month = this.tanggal.getMonth() + 1
            let year = this.tanggal.getFullYear()
            this.date.monthIndex = month
            this.date.year = year
        },
        showDate(date) {
            this.date = date
        },

        /**
         * VALIDATION DATA
         */
        submitForm() {
            this.$v.$touch()
            if(this.$v.$invalid) {
            } else {
                this.goSave()
                this.loading = true
            }
        },

        getDataSetting() {
            DataApi.post('shift/setting/lihat')
            .then( res => {
                let temp = res.data
                if(temp.success == true) {
                    this.dataSetting = temp.data
                } else {
                    this.dataSetting = []
                }
            })
        },
        goSettings() {
            this.$refs.settings.isShown = true
            this.$refs.settings.data = {...this.dataSetting}
        },
        goSaveSetting(value) {
            DataApi.post('shift/setting/simpan', value)
            .then( res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.getDataSetting()
                this.$refs.settings.closePopUp()
                this.loading = false
                this.currentAlertCounter = 2
            })
        },
        getBackFront(value) {
            this.moving('main')
            this.alertMess = value.mess
            this.success = value.succ
            this.currentAlertCounter = 2
            this.getData()
        },
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
        this.getDataSetting()
        this.getDataUnit()
        this.setDate()
    },
    computed: {
        matchesUnit() {
            if (this.queryUnit == '') {
                return [];
            }
            return this.dataUnit.filter((item) => item['text'].toLowerCase().includes(this.queryUnit.toLowerCase()))
        },
    }
}
</script>
<style scoped>
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
@media screen and (min-width: 1253px) and (max-width: 1358px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1168px) and (max-width: 1252px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1097px) and (max-width: 1167px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1036px) and (max-width: 1096px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 992px) and (max-width: 1035px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1359px){
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}
.btn-search {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(360deg);
    transition: 300ms linear all;
}
.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input textarea, .area-input .model-select {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.alert-area {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 16px;
    padding-bottom: 16px;
    background-color: rgba(48, 107, 221, 1);
    text-align: center;
    color: white;
    font-size: 14px;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(0deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 24px;
    padding-right: 24px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 12px;
    padding-right: 24px;
    padding-left: 24px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}
::v-deep .month-picker__container {
    z-index: 5 !important;
    width: 250px;
}
::v-deep .month-picker__year button {
    width: 50px;
    height: 48px;
}
::v-deep .month-picker-input {
    display: block;
    width: 100%;
    height: calc(1.5em + .75rem + 2px);
    padding: .375rem .75rem;
    font-size: .875rem;
    font-weight: 400;
    line-height: 1.5;
    background-clip: padding-box;
    border: 1px solid;
    color: #768192;
    border-color: #d8dbe0;
    background-color: #f9fafc;
    border-radius: .25rem;
}
::v-deep .month-picker-input-container {
    width: 100%;
    min-width: none;
}

.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
</style>